import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import theme from "@irati/ui/src/global/theme"
import emptyGraph from "@irati/ui/images/empty-graph.svg"

import {ADD_TEAM} from "../../../routes/routeConfig"

const EmptyTeams: FC = () => {
  return (
    <Flex direction="column" alignItems="center" padding={[15, 0]}>
      <img src={emptyGraph} alt="emptyGraph" />
      <Body marginTop={2} color={theme.colors.utility.subdued}>
        <FormattedMessage id="admin.components.teamEngagement.empty.text1" />
      </Body>
      <Body margin={[2, 0]} color={theme.colors.utility.subdued}>
        <FormattedMessage id="admin.components.teamEngagement.empty.text2" />
      </Body>
      <ButtonRouterLink primary to={ADD_TEAM}>
        <FormattedMessage id="admin.components.teamEngagement.empty.button" />
      </ButtonRouterLink>
    </Flex>
  )
}

export default EmptyTeams
